module.exports = __webpack_public_path__ + "static/media/Template_FullColor.63b9da6d.png";